import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { API } from '../../services/axios.service';
import ApiUrls from '../../helper/ApiUrls';


const initialState = {
    data: [],
    dataByPage: {},
    currentPage: 1,
    totalPages: 0,
    status: 'idle',
    error: '',

};


export const fetchChambers = createAsyncThunk(
    'chambers',
    async ({ page, limit, forceReload = false }, { getState }) => {
        const state = getState();

        if (!forceReload && state.doctors.dataByPage[page]) {
            return { page, data: state.doctors.dataByPage[page] };
        }

        const response = await API.get(`${ApiUrls.CHAMBER_LIST}?page=${page}&limit=${limit}`);
        return {
            page,
            data: response.data.data,
            totalPages: response.data.data.total_pages??0,
            totalChatbots: response.data.data.total_doctors??0,
        };
    }
);



export const chambersSlice = createSlice({
    name: 'chambers',
    initialState,
    reducers: {
        resetChamberList:()=>{
            
        },

    },
    extraReducers: {
        [fetchChambers.pending]: (state) => {
            state.status = 'loading';
        },
        [fetchChambers.fulfilled]: (state, action) => {
            state.status = 'succeeded';
            state.data=action.payload.data;
            if (action.payload.totalPages) {
                state.totalPages = action.payload.totalPages;
            }
        },
        [fetchChambers.rejected]: (state, action) => {
            state.status = 'failed';
            state.error = action.error.message;
        },
        //  for my assistants
        
    },
});

// Action creators are generated for each case reducer function
export const { resetChamberList } = chambersSlice.actions;
export default chambersSlice.reducer;
